import AuthProvider from './AuthProvider';

export default AuthProvider;
